var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center flex-column justify-center",staticStyle:{"min-height":"400px"}},[_c('MyLoader'),_c('p',{staticClass:"mt-3 mb-0 font-size--17 font-weight-bold"},[_vm._v(" 휴대폰 본인 인증이 진행중입니다... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }